/* globals AWS, apigClientFactory */

(function(window, angular, undefined) {
    angular.module('formApp')
        .service('errorHandler', ['$state', '$rootScope','LoadingInterceptor', '$timeout', function($state, $rootScope, LoadingInterceptor, $timeout) {  
            
            
            this.reportErrors = function(fault,handle,type,args,headers) {

                console.log(fault,handle,type);

                var ridVal,
                    sidVal;
      
				if(handle === 'redirect' && type !== 'retrieve' && type !== 'retrieve-ec'){

                    if (fault.config && fault.config.headers){
                        ridVal = fault.config.headers['x-request-id-for-tracing'];
                        sidVal = fault.config.headers['x-session-id-for-tracing'];
                    }
                    else{
                        ridVal = "ridValXX";
                        sidVal = "sidValXX";
                    }
             
                    LoadingInterceptor.resetRequests();
                    if (fault.data && fault.data.errorType === 'rating'){

                       var etypevar = "rating";
                       
                        $state.go('error', {forward: false, message:type, etype: etypevar, rid:fault.config.headers['x-request-id-for-tracing'],sid:fault.config.headers['x-session-id-for-tracing']});
                    }
                    else{
                        $state.go('error', {forward: false, message:type, etype:args,rid:ridVal,sid:sidVal}); 
                    }
                }
                else if ((handle === 'decryptionFailed' && fault.status === 404) || (fault.data && fault.data === 'decryptionFailed')) {
                    LoadingInterceptor.resetRequests();
                    $state.go(type, { forward: false, message: type, etype: args, rid: fault.config.headers['x-request-id-for-tracing'], sid: fault.config.headers['x-session-id-for-tracing'] });
                }
                else if(handle === 'redirect' && type === 'retrieve'){
                    LoadingInterceptor.resetRequests();
                    $state.go('retrieve-error', {forward: false, message:type, etype:args,rid:fault.config.headers['x-request-id-for-tracing'],sid:fault.config.headers['x-session-id-for-tracing']});
                }
                else if(handle === 'redirect' && type === 'retrieve-ec'){
                    LoadingInterceptor.resetRequests();
                    var errorCode = '';
                    if (fault.data && fault.data.code === 'EXPIRED_ACTIVATION_DATE'){
                        errorCode = 'expired';
                    }
                    $state.go('retrieve-ec-error', {forward: false, message:type, etype:errorCode,rid:fault.config.headers['x-request-id-for-tracing'],sid:fault.config.headers['x-session-id-for-tracing']});
                }
                // else {
                //   //  logError(fault);
                //   console.log(fault,handle,type);
                // }
				
            };
            	
        }]);
		
		
})(window, window.angular);